import type { DisclaimerProps as DesignSystemDisclaimerProps } from '@repo/design-system-kit';
import type { PaymentMethod } from '@repo/payment-links-kit/types';
import { PaymentMethodStatusValue } from '@repo/payment-links-kit/types';

type StatusValue = (typeof PaymentMethodStatusValue)[keyof typeof PaymentMethodStatusValue];

type DisclaimerConfig = Partial<
  Record<
    StatusValue,
    {
      level: DesignSystemDisclaimerProps['level'];
      translationId: string;
      translationParams?: Record<string, string>;
    }
  >
>;

const disclaimerConfig: DisclaimerConfig = {
  [PaymentMethodStatusValue.METHOD_STATUS_VALUE_INACTIVE]: {
    level: 'info',
    translationId: 'payment-links-kit.payment-methods.sidebar.disclaimer.inactive',
  },
  [PaymentMethodStatusValue.METHOD_STATUS_VALUE_PENDING_REVIEW]: {
    level: 'info',
    translationId: 'payment-links-kit.payment-methods.sidebar.disclaimer.pending-review',
  },
  [PaymentMethodStatusValue.METHOD_STATUS_VALUE_PENDING_EXTERNAL]: {
    level: 'warning',
    translationId: 'payment-links-kit.payment-methods.sidebar.disclaimer.pending-external',
  },
  [PaymentMethodStatusValue.METHOD_STATUS_VALUE_PENDING_ONBOARDING]: {
    level: 'warning',
    translationId: 'payment-links-kit.payment-methods.sidebar.disclaimer.pending-boarding',
  },
  [PaymentMethodStatusValue.METHOD_STATUS_VALUE_REJECTED]: {
    level: 'error',
    translationId: 'payment-links-kit.payment-methods.toasts.reject',
  },
};

export function shouldShowDisclaimer(paymentMethod: PaymentMethod): boolean {
  const status = paymentMethod.status?.value;

  if (!status) {
    return false;
  }

  if (
    status === PaymentMethodStatusValue.METHOD_STATUS_VALUE_INACTIVE &&
    paymentMethod.id !== 'apple_pay'
  ) {
    return false;
  }

  const config = disclaimerConfig[status];
  return Boolean(config);
}

export { disclaimerConfig };
export type { StatusValue, DisclaimerConfig };
